































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import EditTrapAnalyse from "./analyse-edit.vue";
import PicTrapAnalyse from "./analyse-pic.vue";
import Ajax from "../../../lib/ajax";
//import Echarts from "./Echarts.vue";

class PageThRealTimeDataRequest extends PageRequest {
  FilterText: string;
  cId: Number;
  etype: number = 1;
  Mac: string;
  Time: string;
  displayId: number;
  startDate: string;
  endDate: string;
  ftId: Number;
  wId: Number;
  fId: Number;
}
class PageCompanyRequest {
  cId: Number;
  ftId: Number;
  wId: Number;
}
@Component({
  components: {EditTrapAnalyse,PicTrapAnalyse},
})
export default class ThRealTimeDatas extends AbpBase {
  pagerequest: PageThRealTimeDataRequest = new PageThRealTimeDataRequest();
  pagecompanyrequest: PageCompanyRequest = new PageCompanyRequest();
  userName: string;
  cId: Number;
  list1;
  totalcount = 0;
  Mac: string = "";
  temp: string = "";
  selwarehouselist = [];
  selfloorlist = [];
  spinShow = false;
  editModalShow: boolean = false;
  picModalShow: boolean = false;
  get list() {
    return this.$store.state.data.list;
  }
  get loading() {
    return this.$store.state.data.loading;
  }
  async handleExport() {
    let filename = "气体检测数据";
    this.spinShow = true;
    // let res =  await this.$store.dispatch({
    //   type: "thdata/exportExcelsummary",
    //   data: this.pagerequest,
    // });
    // console.log(res);
    // const blob = new Blob([res.data]); // 把得到的结果用流对象转一下
    //   var a = document.createElement("a"); //创建一个<a></a>标签
    //   a.href = URL.createObjectURL(blob); // 将流文件写入a标签的href属性值
    //   a.download = filename+".xls"; //设置文件名
    //   a.style.display = "none"; // 障眼法藏起来a标签
    //   document.body.appendChild(a); // 将a标签追加到文档对象中
    //   a.click(); // 模拟点击了a标签，会触发a标签的href的读取，浏览器就会自动下载了
    //   a.remove(); // 一次性的，用完就删除a标签
    await Ajax.post(
      "/api/services/app/InairData/ExportExcelsummary",
      this.pagerequest,
      {
        responseType: "blob",
      }
    ).then((res) => {
      this.spinShow = false;
      const blob = new Blob([res.data]); // 把得到的结果用流对象转一下
      var a = document.createElement("a"); //创建一个<a></a>标签
      a.href = URL.createObjectURL(blob); // 将流文件写入a标签的href属性值
      a.download = filename + ".xls"; //设置文件名
      a.style.display = "none"; // 障眼法藏起来a标签
      document.body.appendChild(a); // 将a标签追加到文档对象中
      a.click(); // 模拟点击了a标签，会触发a标签的href的读取，浏览器就会自动下载了
      a.remove(); // 一次性的，用完就删除a标签
    });
  }
  edit() {
    this.editModalShow = true;
  }
  pic(){
      this.picModalShow = true;
  }
  selCompany(value: Number) {
    this.pagecompanyrequest.cId = value;
    this.getfactory();
    this.getwarehouse();
    this.getfloor();
    this.getPage();
  }
  //库区
  selfactory(value: Number) {
    this.pagecompanyrequest.ftId = value;
    // this.getwarehouse();
    //   this.getfloor();
    if (value != 0) {
      this.getselwarehouse();
    } else {
      this.selwarehouselist = [];
      this.selfloorlist = [];
    }
    this.$store.state.data.currentPage = 1;
    this.getPage();
  }
  //库房
  selwarehouse(value: Number) {
    this.pagecompanyrequest.wId = value;
    // this.getfloor();
    if (value != 0 && value != undefined) {
      this.getselfloor();
    } else {
      this.selfloorlist = [];
    }
    this.$store.state.data.currentPage = 1;
    this.getPage();
  }
  //楼层
  selfloor(value: Number) {
    this.$store.state.data.currentPage = 1;
    this.getPage();
  }
  dateChange(e) {
    if (e[0].length == 0) {
       this.pagerequest.startDate = "0001/1/1 0:00:00";
      this.pagerequest.endDate = "0001/1/1 0:00:00";
    } else {
      this.pagerequest.startDate = e[0];
      this.pagerequest.endDate = e[1];
    }
  }
  getsearch() {
    this.$store.state.data.currentPage = 1;
    this.getPage();
  }
  pageChange(page: number) {
    this.$store.commit("data/setCurrentPage", page);
    this.getPage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("data/setPageSize", pagesize);
    this.getPage();
  }
  async getPage() {
    this.pagerequest.etype = 1;
    this.pagerequest.maxResultCount = this.pageSize;
      this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    
    //filters
    await this.$store.dispatch({
      type: "data/getPaged",
      data: this.pagerequest,
    });
  }

  get pageSize() {
    return this.$store.state.data.pageSize;
  }
  get totalCount() {
    return this.$store.state.data.totalCount;
  }
  get currentPage() {
    return this.$store.state.data.currentPage;
  }
  getuserName() {
    this.userName = this.$store.state.session.user
      ? this.$store.state.session.user.name
      : "";
    return this.userName;
  }
  get company() {
    return this.$store.state.company.list;
  }
  companylist() {
    return this.$store.state.company.list;
  }
  get warehouse() {
    return this.$store.state.warehouse.list;
  }
  get floor() {
    return this.$store.state.floor.list;
  }
  get factory() {
    return this.$store.state.factory.list;
  }
  factorylist() {
    return this.$store.state.factory.list;
  }
  warehouselist() {
    return this.$store.state.warehouse.list;
  }
  floorlist() {
    return this.$store.state.floor.list;
  }
  get smokecrib() {
    return this.$store.state.smokecrib.list;
  }
  smokecriblist() {
    return this.$store.state.smokecrib.list;
  }

  columns = [
    {
      title: "所属公司",
      key: "cId",
      render: (h, params) => {
        let cId = params.row.cId;
        let clist = this.companylist();
        for (let entry of clist) {
          if (cId == entry.id) {
            cId = entry.cName;
            break;
          }
        }
        if (cId == 0) {
          cId = "";
        }
        return h("span", cId);
      },
    },
    {
      title: "库区",
      key: "ftId",
      render: (h, params) => {
        let Id = params.row.ftId;
        let flist = this.factorylist();
        for (let entry of flist) {
          if (Id == entry.id) {
            Id = entry.fName;
            break;
          }
        }
        return h("span", Id);
      },
    },
    {
      title: "库房",
      key: "wId",
      render: (h, params) => {
        let wId = params.row.wId;
        let wlist = this.warehouselist();
        for (let entry of wlist) {
          //console.log(entry.id); // 1, "string", false
          if (wId == entry.id) {
            wId = entry.wName;
            break;
          }
        }
        return h("span", wId);
      },
    },
    {
      title: "楼层",
      key: "fId",
      render: (h, params) => {
        let fId = params.row.fId;
        let flist = this.floorlist();
        for (let entry of flist) {
          //console.log(entry.id); // 1, "string", false
          if (fId == entry.id) {
            fId = entry.fName;
            break;
          }
        }
        return h("span", fId);
      },
    },
    {
      title: "SN号",
      key:"mac",
    },
    {
      title: "虫子数量",
      key: "numbler",
    },
    {
      title: "状态",
      key: "status",
      render: (h, params) => {
        let status = params.row.status;
        if (status == 0) {
          return h("span", "等待分析");
        } else if (status == 1) {
          return h("span", "已分析");
        }
      },
    },
    // {
    //   title: "分析时间",
    //   key: "analyseTime",
    //   render: (h, params) => {
    //     let analyseTime = "";
    //     analyseTime =
    //       this.GetDay(params.row.analyseTime) +
    //       " " +
    //       this.GetMinutes(params.row.analyseTime);
    //     return h("span", analyseTime);
    //   },
    // },
    {
      title: "增加数量",
      key: "addNumber",
    },
    {
      title: "更新时间",
      key: "addTime",
      render: (h, params) => {
        let addtime = "";
        addtime =
          this.GetDay(params.row.addTime) +
          " " +
          this.GetMinutes(params.row.addTime);
        return h("span", addtime);
      },
    },
    {
      title: "操作",
      key: "Actions",
      width: 160,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: () => {
                  //console.log(params.row);
                  this.$store.commit("data/edit", params.row);
                  this.edit();
                },
              },
            },
            this.L("Edit")
          ),
          h(
            "Button",
            {
              props: {
                type: "warning",  
                size: "small",
              },
              on: {
                click: async () => {
                   this.$store.commit("data/edit", params.row);
                   this.pic();
                },
              },
            },
            "查看图片"
          ),
        ]);
      },
    },
  ];

  async getcompany() {
    //filters
    await this.$store.dispatch({
      type: "company/getAll",
    });
  }

  GetDay(time) {
    let date = new Date(time);
    let Str =
      date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
    return Str;
  }

  GetMinutes(time) {
    let date = new Date(time);
    let Str =
      this.GetBqMinutes(date.getHours()) +
      ":" +
      this.GetBqMinutes(date.getMinutes());
    return Str;
  }
  GetBqMinutes(str) {
    if (str.toString().length == 1) {
      return "0" + str;
    }
    return str;
  }
  async getsmokecrib() {
    //烟叶
    //filters
    await this.$store.dispatch({
      type: "smokecrib/getAll",
      data: this.pagecompanyrequest,
    });
  }
  async getwarehouse() {
    //库房
    //filters
    await this.$store.dispatch({
      type: "warehouse/getAll",
      data: this.pagecompanyrequest,
    });
  }
  async getfactory() {
    //库区
    //filters
    await this.$store.dispatch({
      type: "factory/getPaged",
      data: this.pagecompanyrequest,
    });
  }
  async getfloor() {
    //楼层
    //filters
    await this.$store.dispatch({
      type: "floor/getAll",
      data: this.pagecompanyrequest,
    });
  }
  async getselwarehouse() {
    this.selwarehouselist = await this.$store.dispatch({
      type: "warehouse/RegetAll",
      data: this.pagecompanyrequest,
    });
  }
  async getselfloor() {
    //下拉库房加载楼层
    //filters
    this.selfloorlist = await this.$store.dispatch({
      type: "floor/RegetAll",
      data: this.pagecompanyrequest,
    });
  }
  created() {
    this.$store.state.data.pageSize = 10;
    this.$store.state.data.currentPage = 1;
    this.$store.state.data.totalCount = 0;
    this.getuserName();
    this.getwarehouse();
    this.getfloor();
    this.getfactory();
    this.getsmokecrib();
    if (this.userName !== "admin") {
      //不符合权限的，你就没有操作这个列名！！！
      this.columns = this.columns.filter((col) => col.title !== "所属公司");
    } else {
      this.getcompany();
    }

    this.getPage();
  }
}
